module.exports = __webpack_public_path__ + "static/akadi-gargauth-eldath-finder_wyvernspur-grumbar-DND3_FnP-25c3ba73286fb282683644c1ba20ec5d.webp";